import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.image-slider',
        slides: '.image-slider__slides',
        slide: '.image-slider__slide',
        dots: '.image-slider__dots',
        dot: '.image-slider__dot',
    },
    classNames: {
        dotActive: 'image-slider__dot--active',
        dotsVisible: 'image-slider__dots--visible'
    },
    dataAttributes: {
        index: 'index'
    },

    sliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        // swipeToSlide: true,
        mobileFirst: true,
        autoplay: false,
        variableWidth: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        draggable: false,
    },
    easeTime: 0.2,
};

class ImageSlider {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isSlider = false;
        this._currentIndex = 0;
    }

    init() {
        this._elements = this._getDomElements();

        if(this._elements.$slide.length > 1) {
            this._elements.$slides.slick(config.sliderConfig);
            this._elements.$dots.html(this._createDotHtml());

            this._elements.$dot = this._$rootElement.find(config.selectors.dot);

            this._addEventListener();
            $(this._elements.$dot[0]).addClass(config.classNames.dotActive);
            this._elements.$dots.addClass(config.classNames.dotsVisible);
        }
    }

    _getDomElements() {
        return {
            $slides: this._$rootElement.find(config.selectors.slides),
            $slide: this._$rootElement.find(config.selectors.slide),
            $dots: this._$rootElement.find(config.selectors.dots),
        };
    }

    _addEventListener() {
        const _this = this;

        this._elements.$dot.on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            const index = $(this).data(config.dataAttributes.index);

            _this._elements.$slides.slick('slickGoTo', index);
            _this._elements.$dot.removeClass(config.classNames.dotActive);
            $(this).addClass(config.classNames.dotActive)
        });

        this._elements.$dot.on('mousedown', function(e) {
            e.stopPropagation();
        });
    }

    _createDotHtml() {
        let html = '';

        this._elements.$slide.each((index, element) => {
            html += `<div class="image-slider__dot" data-index="${index}"></div>`

        });

        return html;
    }
}

moduleRegistry.registerModule('ImageSlider', ImageSlider);
moduleRegistry.autoApplyModule('ImageSlider', config.selectors.root);
